import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["role", "children"];
import { createContext, useContext } from 'react';
import { Breadcrumbs } from '../Breadcrumbs/Breadcrumbs';
import { jsx as _jsx } from "react/jsx-runtime";
const BackButtonContext = /*#__PURE__*/createContext({
  backButton: false
});
export const useBackButtonContext = () => {
  const backButtonContext = useContext(BackButtonContext);
  return backButtonContext;
};
export const BackButton = _ref => {
  let {
      role = 'navigation',
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(BackButtonContext.Provider, {
    value: {
      backButton: true
    },
    children: /*#__PURE__*/_jsx(Breadcrumbs, Object.assign({}, rest, {
      flush: true,
      role: role,
      children: children
    }))
  });
};